import en from './en';

export const glossaryTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
